/* eslint-disable jira/filename-case */
/* eslint-disable @atlassian/relay/unused-fields */
import { graphql } from 'react-relay';

// FIXME - this should live with it's component, not as a constant...
export const GET_COMPASS_COMPONENTS_SCORECARDS_QUERY = graphql`
	query getCompassComponentsScorecardsQuery($componentId: ID!) {
		compass @optIn(to: "compass-beta") {
			component(id: $componentId) {
				__typename
				... on CompassComponent {
					name
					scorecards {
						id
						name
						scorecardScore(query: { componentId: $componentId }) {
							totalScore
							maxTotalScore
						}
					}
				}
				... on QueryError {
					message
					extensions {
						statusCode
						errorType
					}
				}
			}
		}
	}
`;
